import React from "react";
import { Outlet } from "react-router-dom";
import ProjectAccess from "./ProjectAccess";
import ProjectManage from "./ProjectManage";
import ProjectView from "./ProjectView";

const ProjectPage = () => (
  <div className="layout-content px-3 sm:px-5 md:px-5">
    <Outlet />
  </div>
);

export { ProjectPage, ProjectAccess, ProjectManage, ProjectView };
